 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import HALFTITLE from '@/components/HalfTitle'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import PREFACE from '@/components/Preface'
 import ACKNOWLEDGEMENTS from '@/components/Acknowledgements'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER4 from '@/components/Chapter4'
 import CHAPTER5 from '@/components/Chapter5'
 import CHAPTER6 from '@/components/Chapter6'
 import CHAPTER7 from '@/components/Chapter7'
 import CHAPTER8 from '@/components/Chapter8'
 import CHAPTER9 from '@/components/Chapter9'
 import CHAPTER10 from '@/components/Chapter10'
 import BIBLIOGRAPHY from '@/components/Bibliography'
 import AUTHOR from '@/components/Author'
 import END from '@/components/End'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Preface",
 			"name" : "Preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/Acknowledgements",
 			"name" : "Acknowledgements",
 			"component" : ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js